export default state => ({ user: state.auth.user })
